module.exports = __webpack_public_path__ + "img/solena_scientist.f2793d14.png";